// extracted by mini-css-extract-plugin
export default {"section":"Skills_section__jJda8","title":"Skills_title__U+y2m","card":"Skills_card__ZKiS9","skillHeader":"Skills_skillHeader__iiqMd","progress":"Skills_progress__iL9XW"};